 import { Component, OnInit,Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import {AttendanceService} from '../../../core/services/attendance.service';
import {LoadingState} from '../../../core/components/loading/loading.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-attendance-approval-form',
  templateUrl: './attendance-approval-form.component.html',
  styleUrls: ['./attendance-approval-form.component.scss']
})
export class AttendanceApprovalFormComponent implements OnInit {

  @Input() appovalFormData:any;
  form: FormGroup;
  loading: LoadingState = LoadingState.NotReady;
  hideRemark:boolean=true;

  constructor(
    private formBuilder: FormBuilder,
    private attendanceService:AttendanceService,
    private router:Router,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    //console.log(this.appovalFormData);
    
    this.form = this.formBuilder.group({
     approved_status:[null,Validators.required],
     remarks:[null,Validators.required],
     logId:[this.appovalFormData.id]
    })

        
  }

  submit(id:number){
    if(this.form.valid)
    {
      //console.log(this.form.value);
     this.loading = LoadingState.Processing;

    //  var data = {
    //     approved_status: this.form.value.approved_status,
    //     remarks:this.form.value.remarks
    //   }
      var status = this.form.value.approved_status
      var status_name = '';
      if(status == 1){
        status_name = 'relese'
      }
      else if(status == 2){
        status_name = 'approved'
      }
      else if(status == 3){
        status_name = 'reject'
      }
      let data = {
        remarks: this.form.value.remarks,
        attendence_approvals: []
      }
      var d = {
        req_id: this.form.value.logId,
        approved_status: status_name
      }
      data['attendence_approvals'].push(d)

        this.attendanceService.updateAttendanceApprovalV2(data).subscribe(
          res=>{
            //console.log(res);
          // this.router.navigateByUrl('/attendance/attendance-approval');
          // this.loading = LoadingState.Ready;
          this.hideRemark = false;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
          });
         
        },
        error=>{
          //console.log(error);
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
          });
        }
      )

    }
    else{
      this.markFormGroupTouched(this.form);
    }
  }


  // 
  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

}
